import shortid from 'shortid';

export default {
    data() {
        return {
            // Be careful, some components
            // may already have this as property.
            isLoading: false,
            isDataReady: false,
            serverError: null,
        };
    },
    computed: {
        componentName() {
            return this.$options.name;
        },
        loaderId() {
            return `${this.componentName || 'component'}-${shortid.generate()}`;
        },
        isDataRequired() {
            return !this.isDataReady;
        },
    },
    methods: {
        startLoadingPage() {
            this.isLoading = true;
            this.$startLoading(this.loaderId);
        },
        stopLoadingPage() {
            this.$stopLoading(this.loaderId);
            this.isLoading = false;
        },
        async loadComponent() {
            if (!this.isDataRequired) {
                return;
            }

            this.startLoadingPage();

            if (!this.fetchData) {
                return;
            }

            try {
                await this.fetchData();
                this.isDataReady = true;
            } catch (error) {
                this.serverError = error;
            } finally {
                this.stopLoadingPage();
            }
        },
    },
    created() {
        // Re-fetch data if one of the specified route params changes
        // See: https://github.com/vuejs/vue-router/issues/1490
        // Watcher only fires if the value is actually changed.
        // So we don't need to explicitly compare against current state.
        if (this.reloadOnParam) {
            // Coerce string into array
            const params = Array.isArray(this.reloadOnParam)
                ? this.reloadOnParam : [this.reloadOnParam];
            params.forEach((param) => {
                this.$watch(param, () => {
                    this.isDataReady = false;
                    this.loadComponent();
                });
            });
        }
        this.loadComponent();
    },
    beforeDestroy() {
        // Make sure to reset the loading state.
        this.stopLoadingPage();
    },
};
